import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.xero.XeroDeliveryDetailsSection', {
    deliveryAddressTitle: 'Delivery address',
    addressLabel: 'Address',
    addressPlaceholder: 'Enter address',
    fieldRequired: 'Field is required',
    fieldMaxLength: 'Maximum length of {maxLength} characters exceeded',
    fieldSpacesOnly: 'Field cannot contain only spaces',
    attentionLabel: 'Attention',
    attentionPlaceholder: 'Enter person',
    phoneLabel: 'Phone',
    phonePlaceholder: 'Enter phone',
    phoneInvalidFormat: 'Invalid phone format',
    deliveryInstructionsLabel: 'Delivery Instructions',
    deliveryInstructionsPlaceholder: 'Enter delivery instructions',
});
